/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApprovalRuleCreate } from '../models/ApprovalRuleCreate';
import type { ApprovalRuleListResponse } from '../models/ApprovalRuleListResponse';
import type { ApprovalRulePatch } from '../models/ApprovalRulePatch';
import type { ApprovalRuleResponse } from '../models/ApprovalRuleResponse';
import type { ApprovalRuleSimulateRequest } from '../models/ApprovalRuleSimulateRequest';
import type { ApprovalRuleSimulateResponse } from '../models/ApprovalRuleSimulateResponse';
import type { ApprovalRuleUpdate } from '../models/ApprovalRuleUpdate';
import type { DefaultApprovalRulePatch } from '../models/DefaultApprovalRulePatch';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ApprovalRuleService {
    /**
     * This method returns all approval rules for a given company
     * @param companyId The company id
     * @returns ApprovalRuleListResponse OK
     * @throws ApiError
     */
    public static getAllApprovalRules(
        companyId: number,
    ): CancelablePromise<ApprovalRuleListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{companyId}/approval-rules',
            path: {
                'companyId': companyId,
            },
            errors: {
                400: `BAD REQUEST`,
                401: `UNAUTHORIZED`,
                403: `FORBIDDEN`,
                500: `INTERNAL SERVER ERROR`,
            },
        });
    }
    /**
     * This method creates an approval rule for a company
     * @param companyId The company id
     * @param requestBody The approval rule request object
     * @returns ApprovalRuleResponse CREATED
     * @throws ApiError
     */
    public static createApprovalRule(
        companyId: number,
        requestBody: ApprovalRuleCreate,
    ): CancelablePromise<ApprovalRuleResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{companyId}/approval-rules',
            path: {
                'companyId': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `BAD REQUEST`,
                401: `UNAUTHORIZED`,
                403: `FORBIDDEN`,
                500: `INTERNAL SERVER ERROR`,
            },
        });
    }
    /**
     * This method returns specific approval rule for a company
     * @param companyId The company id
     * @param approvalRuleId The approval rule id
     * @returns ApprovalRuleResponse OK
     * @throws ApiError
     */
    public static getApprovalRuleById(
        companyId: number,
        approvalRuleId: number,
    ): CancelablePromise<ApprovalRuleResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/companies/{companyId}/approval-rules/{approvalRuleId}',
            path: {
                'companyId': companyId,
                'approvalRuleId': approvalRuleId,
            },
            errors: {
                400: `BAD REQUEST`,
                401: `UNAUTHORIZED`,
                403: `FORBIDDEN`,
                500: `INTERNAL SERVER ERROR`,
            },
        });
    }
    /**
     * This method patches an approval rule
     * @param companyId The company id
     * @param approvalRuleId The approval rule id
     * @param requestBody Approval Rule to patch
     * @returns ApprovalRuleResponse OK
     * @throws ApiError
     */
    public static patchApprovalRuleById(
        companyId: number,
        approvalRuleId: number,
        requestBody: ApprovalRulePatch,
    ): CancelablePromise<ApprovalRuleResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/companies/{companyId}/approval-rules/{approvalRuleId}',
            path: {
                'companyId': companyId,
                'approvalRuleId': approvalRuleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `BAD REQUEST`,
                401: `UNAUTHORIZED`,
                403: `FORBIDDEN`,
                404: `NOT FOUND`,
                500: `INTERNAL SERVER ERROR`,
            },
        });
    }
    /**
     * This method updates an approval rule
     * @param companyId The company id
     * @param approvalRuleId The approval rule id
     * @param requestBody The approval rule object
     * @returns ApprovalRuleResponse OK
     * @throws ApiError
     */
    public static updateApprovalRuleById(
        companyId: number,
        approvalRuleId: number,
        requestBody: ApprovalRuleUpdate,
    ): CancelablePromise<ApprovalRuleResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/companies/{companyId}/approval-rules/{approvalRuleId}',
            path: {
                'companyId': companyId,
                'approvalRuleId': approvalRuleId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `BAD REQUEST`,
                401: `UNAUTHORIZED`,
                403: `FORBIDDEN`,
                404: `NOT FOUND`,
                409: `CONFLICT`,
                500: `INTERNAL SERVER ERROR`,
            },
        });
    }
    /**
     * Delete approval rule for company
     * @param companyId The company id
     * @param approvalRuleId The approval rule id
     * @returns void
     * @throws ApiError
     */
    public static deleteApprovalRuleById(
        companyId: number,
        approvalRuleId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/companies/{companyId}/approval-rules/{approvalRuleId}',
            path: {
                'companyId': companyId,
                'approvalRuleId': approvalRuleId,
            },
            errors: {
                400: `BAD REQUEST`,
                401: `UNAUTHORIZED`,
                403: `FORBIDDEN`,
                404: `NOT FOUND`,
                500: `INTERNAL SERVER ERROR`,
            },
        });
    }
    /**
     * This method patches an approval rule
     * @param companyId The company id
     * @param requestBody Approval Rule to patch
     * @returns ApprovalRuleResponse OK
     * @throws ApiError
     */
    public static patchDefaultApprovalRule(
        companyId: number,
        requestBody: DefaultApprovalRulePatch,
    ): CancelablePromise<ApprovalRuleResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/companies/{companyId}/approval-rules/default',
            path: {
                'companyId': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `BAD REQUEST`,
                401: `UNAUTHORIZED`,
                403: `FORBIDDEN`,
                404: `NOT FOUND`,
                500: `INTERNAL SERVER ERROR`,
            },
        });
    }
    /**
     * Simulates how the Approval Rule Engine would route a sample expense
     * This method simulates which approval rules would match a sample expense and what the final approval result would be without affecting real expenses
     * @param companyId The company id
     * @param requestBody
     * @returns ApprovalRuleSimulateResponse OK
     * @throws ApiError
     */
    public static simulateApprovalRules(
        companyId: number,
        requestBody: ApprovalRuleSimulateRequest,
    ): CancelablePromise<ApprovalRuleSimulateResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/companies/{companyId}/approval-rules/simulate',
            path: {
                'companyId': companyId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `BAD REQUEST`,
                401: `UNAUTHORIZED`,
                403: `FORBIDDEN`,
                404: `NOT FOUND`,
                500: `INTERNAL SERVER ERROR`,
            },
        });
    }
}
